import { AttendanceStatusModule_fromInt, AttendanceStatusModule_isSeated, SeatingStyle, SeatingStyleModule_toInt, TableShape, TableShapeModule_toInt, SeatingStyleModule_fromInt, TableShapeModule_fromInt } from "../Shared/Types.js";
import { ta, t as t_1 } from "../Lang.js";
import { Common_actions, Tables_noTables, Tables_add, Common_delete, Common_edit, Tables_honor, Common_cancel, Common_save, Tables_countLabel, Tables_honorCheckbox, Tables_seating, Tables_totalComputed, Tables_seatsHead, Tables_seatsLongSide, Tables_capacity, Tables_shape, Tables_namePlaceholder, Tables_name, Tables_editTable, Tables_newTable, Tables_warningSeatsShort, Tables_summaryShort, Tables_summaryEmpty, Tables_summary, Enum_Seating_allsides, Enum_Seating_oneside, Enum_Shape_round, Enum_Shape_square, Enum_Shape_oval, Enum_Shape_rectangular } from "../Shared/Tr.js";
import { indexed, singleton as singleton_1, isEmpty, filter, sumBy, length, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { equals, createObj, int32ToString } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { tryParse, op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { createElement } from "react";
import { collect, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Msg } from "../App/Messages.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { helpIcon, numericInput } from "./Components.js";
import { tablesOnlyPreview } from "./ArrangementDetail.js";

function shapeLabel(s) {
    const matchValue = TableShapeModule_fromInt(s);
    switch (matchValue.tag) {
        case 1:
            return t_1(Enum_Shape_rectangular);
        case 2:
            return t_1(Enum_Shape_oval);
        case 3:
            return t_1(Enum_Shape_square);
        default:
            return t_1(Enum_Shape_round);
    }
}

function seatingLabel(s) {
    const matchValue = SeatingStyleModule_fromInt(s);
    if (matchValue.tag === 1) {
        return t_1(Enum_Seating_oneside);
    }
    else {
        return t_1(Enum_Seating_allsides);
    }
}

function shapeOptions() {
    return ofArray([[TableShapeModule_toInt(new TableShape(0, [])), t_1(Enum_Shape_round)], [TableShapeModule_toInt(new TableShape(1, [])), t_1(Enum_Shape_rectangular)], [TableShapeModule_toInt(new TableShape(2, [])), t_1(Enum_Shape_oval)], [TableShapeModule_toInt(new TableShape(3, [])), t_1(Enum_Shape_square)]]);
}

function seatingOptions() {
    return ofArray([[SeatingStyleModule_toInt(new SeatingStyle(0, [])), t_1(Enum_Seating_allsides)], [SeatingStyleModule_toInt(new SeatingStyle(1, [])), t_1(Enum_Seating_oneside)]]);
}

function summaryBar(tables, guestCount) {
    let tupledArg, tupledArg_1, tupledArg_2, elems;
    const tableCount = length(tables) | 0;
    const seatCount = sumBy((t) => t.Capacity, tables, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) | 0;
    const seatsShort = (guestCount > seatCount) && (tableCount > 0);
    const empty = (seatCount - guestCount) | 0;
    const summaryText = ((tupledArg = Tables_summary(int32ToString(tableCount), int32ToString(seatCount), int32ToString(guestCount)), ta(tupledArg[0], tupledArg[1]))) + ((empty >= 0) ? (" → " + ((tupledArg_1 = Tables_summaryEmpty(int32ToString(empty)), ta(tupledArg_1[0], tupledArg_1[1])))) : (" → " + ((tupledArg_2 = Tables_summaryShort(int32ToString(op_UnaryNegation_Int32(empty))), ta(tupledArg_2[0], tupledArg_2[1])))));
    return createElement("div", createObj(ofArray([["className", "table-summary-bar"], (elems = toList(delay(() => append(singleton(createElement("span", {
        className: seatsShort ? "text-sm summary-warning" : "text-sm text-muted",
        children: summaryText,
    })), delay(() => (seatsShort ? singleton(createElement("span", {
        className: "text-sm summary-warning-icon",
        children: t_1(Tables_warningSeatsShort),
    })) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function tableEditForm(form, dispatch) {
    let elems_16;
    const title = (form.Id == null) ? t_1(Tables_newTable) : t_1(Tables_editTable);
    return createElement("div", createObj(ofArray([["className", "card table-edit-form"], (elems_16 = toList(delay(() => append(singleton(createElement("h3", {
        className: "mb-1",
        children: title,
    })), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = form.Error, (matchValue_1 == null) ? (empty_1()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue_1,
        }))), delay(() => {
            let elems_3, elems, elems_2, elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_3 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
                children: t_1(Tables_name),
            }), createElement("input", {
                className: "form-input",
                type: "text",
                placeholder: t_1(Tables_namePlaceholder),
                value: form.Name,
                onChange: (ev) => {
                    dispatch(new Msg(144, [ev.target.value]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                children: t_1(Tables_shape),
            }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.Shape)], ["onChange", (ev_1) => {
                let matchValue_2;
                let outArg = 0;
                matchValue_2 = [tryParse(ev_1.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_2) => {
                    outArg = (v_2 | 0);
                })), outArg];
                if (matchValue_2[0]) {
                    dispatch(new Msg(145, [matchValue_2[1]]));
                }
            }], (elems_1 = toList(delay(() => collect((matchValue_3) => singleton(createElement("option", {
                value: int32ToString(matchValue_3[0]),
                children: matchValue_3[1],
            })), shapeOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_10;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_10 = toList(delay(() => {
                    let elems_4, isOneSided, computedTotal, elems_5;
                    return append(equals(TableShapeModule_fromInt(form.Shape), new TableShape(0, [])) ? singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_4 = [createElement("label", {
                        children: t_1(Tables_capacity),
                    }), numericInput(int32ToString(form.Capacity), (n_1) => {
                        dispatch(new Msg(146, [n_1]));
                    }, 1, 50)], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : ((isOneSided = equals(SeatingStyleModule_fromInt(form.SeatingStyle), new SeatingStyle(1, [])), (computedTotal = ((isOneSided ? form.SeatsLongSide : ((2 * form.SeatsLongSide) + (2 * form.SeatsShortEnd))) | 0), append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("label", {
                        children: t_1(Tables_seatsLongSide),
                    }), numericInput(int32ToString(form.SeatsLongSide), (n_2) => {
                        dispatch(new Msg(147, [n_2]));
                    }, 1, 25)], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                        let elems_6;
                        return append(!isOneSided ? singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_6 = [createElement("label", {
                            children: t_1(Tables_seatsHead),
                        }), numericInput(int32ToString(form.SeatsShortEnd), (n_3) => {
                            dispatch(new Msg(148, [n_3]));
                        }, 0, 10)], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty_1(), delay(() => {
                            let elems_7;
                            return singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_7 = [createElement("label", {
                                children: t_1(Tables_totalComputed),
                            }), createElement("span", {
                                className: "form-computed-value",
                                children: int32ToString(computedTotal),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                        }));
                    }))))), delay(() => {
                        let elems_9, elems_8;
                        return singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_9 = [createElement("label", {
                            children: t_1(Tables_seating),
                        }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.SeatingStyle)], ["onChange", (ev_2) => {
                            let matchValue_4;
                            let outArg_1 = 0;
                            matchValue_4 = [tryParse(ev_2.target.value, 511, false, 32, new FSharpRef(() => outArg_1, (v_4) => {
                                outArg_1 = (v_4 | 0);
                            })), outArg_1];
                            if (matchValue_4[0]) {
                                dispatch(new Msg(149, [matchValue_4[1]]));
                            }
                        }], (elems_8 = toList(delay(() => collect((matchValue_5) => singleton(createElement("option", {
                            value: int32ToString(matchValue_5[0]),
                            children: matchValue_5[1],
                        })), seatingOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                    let elems_12, elems_11;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_12 = [createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems_11 = [createElement("input", {
                        type: "checkbox",
                        checked: form.IsHonorTable,
                        onChange: (ev_3) => {
                            dispatch(new Msg(150, [ev_3.target.checked]));
                        },
                    }), createElement("span", {
                        children: t_1(Tables_honorCheckbox),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                        let elems_14, elems_13;
                        return append((form.Id == null) ? singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_14 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_13 = [createElement("label", {
                            children: t_1(Tables_countLabel),
                        }), numericInput(int32ToString(form.Count), (n_5) => {
                            dispatch(new Msg(151, [n_5]));
                        }, 1, 50)], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty_1(), delay(() => {
                            let elems_15;
                            return singleton(createElement("div", createObj(ofArray([["className", "flex gap-sm mt-1"], (elems_15 = [createElement("button", {
                                className: "btn btn-primary",
                                children: t_1(Common_save),
                                disabled: form.IsSubmitting,
                                onClick: (_arg) => {
                                    dispatch(new Msg(152, []));
                                },
                            }), createElement("button", {
                                className: "btn btn-secondary",
                                children: t_1(Common_cancel),
                                onClick: (_arg_1) => {
                                    dispatch(new Msg(143, []));
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

function tableRow(table, index, dispatch) {
    let elems_1, children, elems;
    return createElement("tr", createObj(ofArray([["className", "table-config-row"], (elems_1 = [createElement("td", {
        children: int32ToString(index + 1),
    }), createElement("td", {
        children: table.Name,
    }), createElement("td", {
        children: shapeLabel(table.Shape),
    }), createElement("td", {
        children: int32ToString(table.Capacity),
    }), createElement("td", {
        children: seatingLabel(table.SeatingStyle),
    }), (children = toList(delay(() => (table.IsHonorTable ? singleton(createElement("span", {
        className: "badge honor-badge",
        children: t_1(Tables_honor),
    })) : empty_1()))), createElement("td", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("td", createObj(ofArray([["className", "table-actions"], (elems = [createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_1(Common_edit),
        onClick: (_arg) => {
            dispatch(new Msg(142, [table]));
        },
    }), createElement("button", {
        className: "btn btn-sm btn-danger",
        children: t_1(Common_delete),
        onClick: (_arg_1) => {
            dispatch(new Msg(155, [table.Id]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function view(state, dispatch) {
    let elems_3;
    const guestCount = length(filter((g) => AttendanceStatusModule_isSeated(AttendanceStatusModule_fromInt(g.AttendanceStatus)), state.Guests)) | 0;
    return createElement("div", createObj(ofArray([["className", "table-layout-container"], (elems_3 = toList(delay(() => append(singleton(summaryBar(state.Tables, guestCount)), delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "table-toolbar"], (elems = [createElement("button", {
            className: "btn btn-primary",
            children: t_1(Tables_add),
            onClick: (_arg) => {
                dispatch(new Msg(142, [undefined]));
            },
        }), helpIcon(() => {
            dispatch(new Msg(268, ["03", undefined]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = state.TableEditForm, (matchValue == null) ? (empty_1()) : singleton(tableEditForm(matchValue, dispatch))), delay(() => {
                let elems_1, elems_2, children_2, children, children_4;
                return append(isEmpty(state.Tables) ? singleton(createElement("div", createObj(ofArray([["className", "card"], (elems_1 = [createElement("p", {
                    className: "text-muted",
                    children: t_1(Tables_noTables),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : singleton(createElement("table", createObj(ofArray([["className", "data-table"], (elems_2 = [(children_2 = singleton_1((children = ofArray([createElement("th", {
                    children: "#",
                }), createElement("th", {
                    children: t_1(Tables_name),
                }), createElement("th", {
                    children: t_1(Tables_shape),
                }), createElement("th", {
                    children: t_1(Tables_capacity),
                }), createElement("th", {
                    children: t_1(Tables_seating),
                }), createElement("th", {
                    children: t_1(Tables_honor),
                }), createElement("th", {
                    children: t_1(Common_actions),
                })]), createElement("tr", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), createElement("thead", {
                    children: reactApi.Children.toArray(Array.from(children_2)),
                })), (children_4 = toList(delay(() => collect((matchValue_1) => singleton(tableRow(matchValue_1[1], matchValue_1[0], dispatch)), indexed(state.Tables)))), createElement("tbody", {
                    children: reactApi.Children.toArray(Array.from(children_4)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => ((state.TableEditForm == null) ? singleton(tablesOnlyPreview(state, dispatch)) : empty_1())));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

